module.exports = __webpack_public_path__ + "static/media/failedIcon (1).a55655f3.svg";